import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constants/colors";

const ProfileManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "120px", // Adjust height as required
    transition: "0.3s",
  };

  const iconStyle = {
    fontSize: "36px",
    flexShrink: 0,
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  const cards = [
    {
      to: "/view-profile",
      label: "View Profile",
      icon: "fa-user-circle",
      iconColor: "#F59E0B", // Golden color for icon
      text: "View your personal information and details.",
    },
    {
      to: "/view-attendance",
      label: "View Attendance",
      icon: "fa-clipboard-check",
      iconColor: "#22C55E", 
      text: "Check your attendance records.",
    },
    {
      to: "/my-schedule",
      label: "My Schedule",
      icon: "fa-calendar-alt",
      iconColor: "#A855F7", 
      text: "View your class timetable for the week.",
    },
  ];

  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">

        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
          {cards.map((card, idx) => (
            <Link to={card.to} key={idx}>
              <div style={cardStyle} className="hover:scale-[1.02] transition">
                <i
                  className={`fas ${card.icon}`}
                  style={{
                    ...iconStyle,
                    color: card.iconColor, 
                  }}
                ></i>
                <div>
                  <h2 style={heading}>{card.label}</h2>
                  <p style={subText}>{card.text}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileManagement;
